import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  board,
}) => new Promise((resolve) => {
  const data = {
    ...board,
    domain,
    user,
  };

  if (board.layouts) { data.layouts = JSON.stringify(board.layouts); }

  if (board.share_details) { data.share_details = JSON.stringify(board.share_details); }

  if (board.properties) { data.properties = JSON.stringify(board.properties); }

  nsApi.post({
    object: 'dashboard',
    action: 'update',
  }, data).then((res) => {
    resolve(res);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
